import { useState, useEffect } from 'react';
import { getAnimationClass } from './../utils';
import TransactionsBox from './transactionsBox';
import AccountingEquation from './accountingEquation';

// Transition intro shown the first time a student sees a `debit-credit2`
// level (design ['1','2']). Layout mirrors the existing DebitCredit
// transition (TransactionsBox + accounting equation) but with copy that
// emphasizes the chain of decisions — increase/decrease first, then
// translating to debits and credits — per the Figma spec.
export default function DebitCredit2({ onComplete }) {
  const [showP, setShowP] = useState(false);
  const [showTransactionsBox, setShowTransactionsBox] = useState(false);
  const [showRight, setShowRight] = useState(false);

  useEffect(() => {
    const timeouts = [];
    let currentTime = 500;

    timeouts.push(setTimeout(() => setShowP(true), currentTime));

    currentTime += 3000;
    timeouts.push(setTimeout(() => {
      setShowTransactionsBox(true);
      setShowRight(true);
    }, currentTime));

    currentTime += 8000;
    timeouts.push(setTimeout(() => onComplete?.(), currentTime));

    return () => timeouts.forEach(clearTimeout);
  }, [onComplete]);

  return (
    <>
      <h1 className="animate-fade-in">Double Entry Accounting</h1>

      <p className={getAnimationClass(showP)}>
        Behind every journal entry is a small chain of decisions. This level walks you through that chain: 1) you’ll decide how a transaction affects the balance sheet (does it increase or decrease?), then 2) translating those effects into debits and credits. Practice it enough, and the logic of <b>double-entry accounting</b> starts to feel automatic.
      </p>

      {showTransactionsBox && (
        <div className={`transition-transactions-financial-statements no-stretch ${getAnimationClass(true)}`}>
          <TransactionsBox />
          <div className={`transition-transactions-financial-statement-formula-container ${getAnimationClass(showRight)}`}>
            <p><b>Level 2:</b> Make Debit and Credit Decisions</p>
            <AccountingEquation firstSign="equals" secondSign="plus" />
            <p><b className="red">Pro Tip:</b> Every transaction requires both a debit and a credit.</p>
          </div>
        </div>
      )}
    </>
  );
}
